import { useTeamEditionStore } from "@/store/teamEdition";
import { openMembershipFullscreenModal } from "@/views/power/components/Modal/MembershipFullscreenModal";
import { mapMemberQueryTab } from "@/views/power/memberCard/tabs";
import { PERSONAL_PERIODS } from "@/views/power/components/VipPackageV2/components/offerChromeOptions";
import type { ProductModalOptions, ProductModalType } from "./types";

/** 按当前身份分流；返回 false 时由 Pay Store 执行原团队弹窗流程。 */
export function routeProductModal(type: ProductModalType, upgrade: boolean, options?: ProductModalOptions): boolean {
  if (useTeamEditionStore().isTeamEdition) return false;
  const period = mapMemberQueryTab(options?.defaultTimeTab, false);
  openMembershipFullscreenModal({
    initialTab: type === "groupMember" ? "group" : type === "power" ? "power" : undefined,
    initialPeriod: PERSONAL_PERIODS.find(item => item.value === period)?.value,
    highlightMemberType: type === "member" ? options?.defaultMemberType ?? (upgrade ? "svip" : undefined) : undefined
  });
  return true;
}
